import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

interface SubMenuPageProps {
  title: string;
  menuItems: { name: string; link: string }[];
}

const SubMenuPage: React.FC<SubMenuPageProps> = ({ title, menuItems }) => {
  return (
    <div className="h-full w-full pl-[34px] pr-[68px] pt-[40px] font-RobotoCondensed">
      <h1 className="mb-[23px] text-[25px] font-bold">{title}</h1>
      <div className="pl-[5px]">
        {menuItems.map((menuItem) => {
          return (
            <div className="border-b border-black/15 pb-[19px] pt-[18px]" key={menuItem.name}>
              <Link className="decoration-none text-lg text-black" to={menuItem.link}>
                {menuItem.name}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const PasswordPreferencesPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Settings – Blank Slate';
  }, []);

  return (
    <SubMenuPage
      title="Settings"
      menuItems={[
        { name: 'Preferences', link: '/preferences' },
        { name: 'Password', link: '/updatePws' },
      ]}
    />
  );
};
